import React from 'react';
import styles from './stat-card.module.scss';

interface StatCardProps {
  title: string;
  value: string | number;
  icon?: React.ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  info?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, trend, info }) => {
  return (
    <div className={styles.statCard}>
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.value}>{value}</div>
        {trend && (
          <div className={`${styles.trend} ${trend.isPositive ? styles.positive : styles.negative}`}>
            {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
          </div>
        )}
        {info && <div className={styles.info}>{info}</div>}
      </div>
      {icon && <div className={styles.icon}>{icon}</div>}
    </div>
  );
};

export default StatCard; 